import { TravelerTranslationModel } from '../models/translation.model';
import { Language } from '@tbums.mono.web/tbums-lib';

export const translationSV: TravelerTranslationModel = {
  language: Language.SV,
  searchPlaceholder: 'Sök hållplats',
  today: 'Idag',
  tomorrow: 'Imorgon',
  list: {
    noStopsTitle: 'Inga hållplatser hittades',
    noStopsHint: 'Kontrollera stavningen eller sök på en annan ort.',
    distanceInfo: 'Avstånd räknas från din position',
  },
  panel: {
    collapse: 'Minimera',
    expand: 'Expandera',
  },
  stop: {
    route: 'Linje',
    replacedTrain: 'Ersätter Tåg',
    towards: 'Mot',
    departs: 'Tid',
    stop: 'Hållplats',
    location: 'Plats',
    active: 'Aktiv',
    reason: 'Orsak',
    vehicleIdentifier: 'Fordon',
    disembarkingOnly: 'Endast avstigande',
  },
  info: {
    about: 'Om',
    content:
      'Denna webbplats visar information om aktuella transportlösningar som erbjuds av Nobina på uppdrag åt den som organiserar den trafik du vill resa med. Det kan vara ersättningstrafik för ett tågbolag, shuttle-bussar till din arbetsplats eller shoppingdestination, eller transfers på uppdrag för din researrangör. \n' +
      'Målet är att du som resenär ska få relevant information om dagens trafik. Sidan visar all bekräftad trafik för de kommande 24 timmarna. Klicka på en hållplats eller avgång för att se mer detaljer och bussens position i realtid. All information du kan finna på denna sida finns även fullt tillgänglig via API för integration till reseappar, reseplanerare och andra tjänster. \n' +
      '\n' +
      'Vi är Nobina, Nordens största kollektivtrafikföretag. Hos oss jobbar 13 000 människor varje dag för att hitta lösningar på ditt vardagspussel och på samhällets stora utmaningar.',
    close: 'Stäng',
    readMore: 'Läs mer på nobina.com',
  },
  error: {
    affectedStopsMissing: 'Det finns ingen trafik för tillfället',
    stopMissing: 'Information för hållplatsen saknas',
    tripMissing: 'Information för turen saknas',
    close: 'Stäng',
  },
  seo: {
    tagline: 'Var är min buss?',
    description:
      'Ersättningstrafik som körs av Nobina på uppdrag av ditt tågbolag. Målet är att du som resenär ska få relevant information om pågående ersättningstrafik.',
  },
  customerDisplay: {
    route: 'Linje',
    destination: 'Destination',
    departures: 'Avgångar',
  },
};
